function hasId(val) {
    return val.id !== undefined;
}
export function getId(val) {
    if (hasId(val)) {
        return val.id;
    }
    return val;
}
//# sourceMappingURL=Identifiable.js.map